import React, { useEffect } from 'react';


const TawkToChat = () => {
    useEffect(() => {
      const s1 = document.createElement("script");
      const s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/6710afff4304e3196ad31262/1iaciv06g';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
  
      // Cleanup function
      return () => {
        s1.remove();
      };
    }, []); // Empty dependency array means this effect runs once on mount
  
    return null; // This component doesn't render anything
  };
  
  export default TawkToChat;